import palleteLight from './light';
import palleteDark from './dark';

const generatePallete = (theme = 'LIGHT', colors = {}) =>
  theme === 'DARK' ? palleteDark(colors) : palleteLight(colors);

export default generatePallete;
